import React from 'react';
import { ProgressDashboard } from './ProgressDashboard';

/**
 * AnalyticsDemo - Demo component for testing analytics dashboard
 */
export const AnalyticsDemo: React.FC = () => {
  return (
    <div className="analytics-demo container mx-auto px-4 py-6">
      <ProgressDashboard />
    </div>
  );
};

export default AnalyticsDemo;